import { format } from 'date-fns'
import { it, enGB } from 'date-fns/locale'

const CardNews = (item) => {
  const { locale, slug, site, featuredImage, date } = item

  return {
    ...item,
    href: `${locale === 'it' ? 'news-ed-eventi' : 'news-and-events'}/${slug}`,
    site: site?.name || 'THESIADGROUP.COM',
    image: {
      url: featuredImage?.url,
      alt: featuredImage?.alternativeText
    },
    date: format(new Date(date), 'd MMM yyyy', { locale: locale === 'it' ? it : enGB }),
    categories: item.categories
  }
}

export default CardNews